import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { WorkOrderObjectSelectionDataFilterInput } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerWorkOrderObjectSelectionListGql } from '../../workOrderQueries';

const requestId = 'uerWorkOrderObjectSelectionList';

export const useUerWorkOrderObjectSelectionList = () => {
    const dispatch = useDispatch();

    const [
        uerWorkOrderObjectSelectionListData,
        uerWorkOrderObjectSelectionListStatus,
        ,
        uerWorkOrderObjectSelectionListRequest,
    ] = useRequest({
        requestId,
        query: uerWorkOrderObjectSelectionListGql,
        withEffect: false,
    });

    const [uerWorkOrderObjectSelectionListReset] = useResetStoreData({ requestId });

    const uerWorkOrderObjectSelectionListMakeRequest = useCallback(
        (wOrderId: number, constructionTypeId?: number, isIncluded?: boolean) => {
            if (!constructionTypeId) {
                return;
            }

            const where: WorkOrderObjectSelectionDataFilterInput = {
                constructionType: { id: { eq: constructionTypeId } },
                ...(typeof isIncluded === 'boolean' && isIncluded ? { isIncluded: { eq: true } } : {}),
            };

            uerWorkOrderObjectSelectionListReset(undefined);
            dispatch(uerWorkOrderObjectSelectionListRequest({ workOrderId: wOrderId, where }));
        },
        [uerWorkOrderObjectSelectionListRequest, uerWorkOrderObjectSelectionListReset, dispatch],
    );

    return {
        uerWorkOrderObjectSelectionListMakeRequest,
        uerWorkOrderObjectSelectionListData,
        uerWorkOrderObjectSelectionListStatus,
    };
};
